import React from "react";

/** Keep an edited draft until commit; accept external updates while pristine. */
export default function useLPDraft<T>(value: T) {
  const [draft, setDraft] = React.useState(value);
  const draftRef = React.useRef(value);
  const dirtyRef = React.useRef(false);

  React.useEffect(() => {
    if (!dirtyRef.current) {
      draftRef.current = value;
      setDraft(value);
    }
  }, [value]);

  const change = (nextValue: T) => {
    dirtyRef.current = true;
    draftRef.current = nextValue;
    setDraft(nextValue);
  };

  const commit = (onChange: (nextValue: T) => void) => {
    if (!dirtyRef.current) {
      return;
    }
    dirtyRef.current = false;
    if (!Object.is(value, draftRef.current)) {
      onChange(draftRef.current);
    }
  };

  return { draft, change, commit };
}
